/* PDP attach module — size select + quick add.
   Server-rendered rows (snippets/attach-module.liquid); this only wires the
   controls. Never touches PDP variant radios, so it stays clear of the
   app.js <variant-selection> vs z__jsProduct attribute-sync conflict. */
(function () {
  window.PXUTheme = window.PXUTheme || {};
  if (window.PXUTheme.jsAttach) { return; } // already loaded — do not re-bind

  function t(key, fallback) {
    var el = document.querySelector('[data-attach]');
    var v = el && el.getAttribute('data-' + key);
    return v || fallback;
  }

  function showError(row, message) {
    var el = row.querySelector('[data-attach-error]');
    if (!el) { return; }
    el.textContent = message;
    el.hidden = false;
  }

  function clearError(row) {
    var el = row.querySelector('[data-attach-error]');
    if (el) { el.hidden = true; el.textContent = ''; }
  }

  // ── telemetry ───────────────────────────────────────────────────────────
  // The module's funnel is otherwise invisible: an order tells us a sock WAS
  // bought (the `_attach` line property), but never how many shoppers saw the
  // strip and ignored it — so a low attach rate cannot be told apart from a
  // module nobody scrolls to. Pushed to the dataLayer the theme already
  // initialises for the click-ID capture; GTM/sGTM forwards from there.
  // Railway logs were the other option and are wrong for this: they retain
  // under an hour, and impressions need weeks.
  // Fire-and-forget and FULLY SWALLOWED — telemetry must never delay or break
  // a customer turn.
  function track(event, payload) {
    try {
      window.dataLayer = window.dataLayer || [];
      var d = { event: event };
      if (payload) {
        for (var k in payload) {
          if (Object.prototype.hasOwnProperty.call(payload, k)) { d[k] = payload[k]; }
        }
      }
      window.dataLayer.push(d);
    } catch (e) { /* never surfaces to the shopper */ }
  }

  function rowInfo(row) {
    var title = row.querySelector('.attach__title');
    return {
      attach_product_id: row.getAttribute('data-product-id') || '',
      attach_product: title ? title.textContent.trim() : ''
    };
  }

  // ── influenced-conversion stamp ─────────────────────────────────────────
  // The `_attach` line property is a LAST-CLICK metric: it only counts a sock
  // added from the strip itself. At HK$126-238 a sock is not an impulse buy —
  // the likely path is see the strip, go read the sock's own PDP, come back
  // days later. That shopper is invisible to `_attach` and to the dataLayer
  // events alike.
  // So stamp the CART when the module is first seen. Cart attributes ride
  // through to the order, and a Shopify cart persists ~2 weeks from last
  // activity — so an order carrying this was placed by someone who saw the
  // module within roughly that window, however they eventually added socks.
  // Private (leading underscore) so it is hidden at checkout, same convention
  // as `_attach` and `_returncover`.
  var SEEN_KEY = '_attach_seen';

  function stampCartSeen() {
    try {
      var cartUrl = (window.PXUTheme.routes && window.PXUTheme.routes.cart_url) || '/cart';
      fetch(cartUrl + '.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          // Only ever stamp an EXISTING cart. Writing to an empty one would
          // CREATE a cart on every PDP scroll-past, filling abandoned-checkout
          // reporting with phantoms. The module renders below add-to-cart, so
          // the flow this measures — add shoe, module comes into view — always
          // has a cart by then. Accepted ceiling: a shopper who sees the strip
          // before adding anything is not counted.
          if (!cart || !cart.item_count) { return; }
          // First impression wins; never re-stamp, or the date walks forward
          // and every pageview costs a POST (the bug the HK attribute block
          // above this file's sibling in theme.liquid already learned).
          if (cart.attributes && cart.attributes[SEEN_KEY]) { return; }
          var attrs = {};
          attrs[SEEN_KEY] = new Date().toISOString().slice(0, 10);
          return fetch(cartUrl + '/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({ attributes: attrs })
          });
        })
        .catch(function () { /* swallowed — never delays or breaks a turn */ });
    } catch (e) { /* swallowed */ }
  }

  // Impression = the module's HEADING at least half on screen. Two deliberate
  // choices, both verified live rather than assumed:
  //   * observe the HEADING, not the module — the strip can be taller than a
  //     phone viewport, so a ratio threshold on the module never fires there;
  //   * threshold 0.5, NOT 1.0. A fully-visible element computes an
  //     intersectionRatio of 0.9999... on sub-pixel layouts, so `threshold: 1.0`
  //     NEVER FIRES. Shipped that way this reports zero impressions forever —
  //     indistinguishable from a module nobody scrolls to, which is the exact
  //     question the telemetry exists to answer.
  // Fires at most once per page load, then disconnects.
  function watchImpression() {
    var mod = document.querySelector('[data-attach]');
    if (!mod || !window.IntersectionObserver) { return; }
    var target = mod.querySelector('.attach__heading') || mod;
    var fired = false;
    var io = new IntersectionObserver(function (entries) {
      if (fired) { return; }
      for (var i = 0; i < entries.length; i++) {
        if (!entries[i].isIntersecting) { continue; }
        fired = true;
        io.disconnect();
        var rows = Array.prototype.slice.call(mod.querySelectorAll('[data-attach-row]'));
        track('attach_impression', {
          attach_rows: rows.length,
          attach_product_ids: rows.map(function (r) {
            return r.getAttribute('data-product-id') || '';
          }).join(',')
        });
        stampCartSeen();
        break;
      }
    }, { threshold: 0.5 });
    io.observe(target);
  }

  window.PXUTheme.jsAttach = {
    // The variant is on the button for single-variant socks, on the select
    // otherwise. Returns '' when nothing is chosen yet.
    variantOf: function (row) {
      var btn = row.querySelector('[data-attach-add]');
      var pinned = btn && btn.getAttribute('data-variant-id');
      if (pinned) { return pinned; }
      var sel = row.querySelector('[data-attach-size]');
      return (sel && sel.value) || '';
    },

    // Mirrors variantOf's two sources in the same precedence, so the value can
    // never come from a different variant than the id being added. Order Type is
    // set by assets/utilities.js on the PDP form path only, and nothing back-fills
    // it at cart render — so a line added here would otherwise reach the order with
    // none. Liquid computes it per variant in snippets/order-type-value.liquid.
    orderTypeOf: function (row) {
      var btn = row.querySelector('[data-attach-add]');
      if (btn && btn.getAttribute('data-variant-id')) {
        return btn.getAttribute('data-order-type') || '';
      }
      var sel = row.querySelector('[data-attach-size]');
      var opt = sel && sel.selectedIndex >= 0 ? sel.options[sel.selectedIndex] : null;
      return (opt && opt.getAttribute('data-order-type')) || '';
    },

    onSize: function (sel) {
      var row = sel.closest('[data-attach-row]');
      if (!row) { return; }
      var btn = row.querySelector('[data-attach-add]');
      if (btn) {
        btn.disabled = !sel.value;
        // A size change after a successful add must not leave the button
        // reading "Added" for a different variant than the one it would add.
        btn.textContent = t('add', 'Add');
        btn.classList.remove('is-added');
      }
      // The thumb is server-rendered from the product's featured image, but a
      // sock's variants are colourways with their own photos. image_tag emitted
      // a srcset — clearing it is REQUIRED, or the browser keeps painting the
      // old image from srcset and the src swap looks like it did nothing.
      var opt = sel.options[sel.selectedIndex];
      var img = row.querySelector('.attach__img');
      var src = opt && opt.getAttribute('data-image');
      if (img && src) {
        img.removeAttribute('srcset');
        img.removeAttribute('sizes');
        img.src = src;
      }
      clearError(row);
      // Only a real choice is an interaction; clearing back to the placeholder
      // is not, or a shopper toggling sizes inflates the funnel's middle step.
      if (sel.value) { track('attach_select', rowInfo(row)); }
    },

    add: function (btn) {
      var row = btn.closest('[data-attach-row]');
      if (!row) { return; }
      var variantId = this.variantOf(row);
      if (!variantId) { return; }   // hard size gate — no default, no guess
      clearError(row);
      btn.disabled = true;
      var cartUrl = (window.PXUTheme.routes && window.PXUTheme.routes.cart_url) || '/cart';
      // `_attach` marks the line as sold by this module. Private (leading
      // underscore) so it is hidden at checkout, same convention as
      // `_returncover`. This is what makes the attach rate a direct count on the
      // orders export instead of a before/after inference.
      var orderType = this.orderTypeOf(row);
      var body = 'id=' + encodeURIComponent(variantId) +
        '&quantity=1&properties%5B_attach%5D=1' +
        // Encode the whole key: it contains a space and CJK characters.
        (orderType ? '&' + encodeURIComponent('properties[Order Type 訂單類別]') + '=' + encodeURIComponent(orderType) : '');
      fetch(cartUrl + '/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: body
      })
        .then(function (r) {
          return r.json().then(function (data) {
            if (!r.ok) { throw data; }
            return data;
          });
        })
        .then(function (item) {
          btn.textContent = t('added', 'Added');
          btn.classList.add('is-added');
          if (window.PXUTheme.jsAjaxCart) { window.PXUTheme.jsAjaxCart.updateView(); }
          // Deliberately no mini-cart panel here, but NOT for the reason this
          // comment used to give. It claimed the header cart badge was part of
          // the confirmation; the header is not sticky
          // (header-group-centered.json enable_sticky: false), so from this
          // below-add-to-cart module the badge is ~1200px above the viewport and
          // confirms nothing. The real — and sufficient — confirmation is the
          // in-row "Added" state on the button the shopper just pressed, right
          // under their cursor.
          // The sibling path (z__jsAjaxCart.js addedToCart) opens the panel and
          // SCROLLS to the trigger first, so "the panel would open off-screen"
          // is no longer a reason on its own. Keeping the quick-add scroll-free
          // is a deliberate choice: yanking the shopper to document top mid-way
          // through picking socks would lose their place. If you ever do add a
          // panel here, scroll to the trigger too, or it opens where nobody can
          // see it.
          track('attach_add', {
            attach_product_id: (item && item.product_id) || '',
            attach_product: (item && item.product_title) || '',
            attach_variant_id: (item && item.variant_id) || '',
            attach_variant: (item && item.variant_title) || '',
            attach_price: (item && item.price) || ''
          });
          if (window.HillmalayaSearchDiscovery) { window.HillmalayaSearchDiscovery.clearCache(); }
          if (window.HillmalayaRecentlyViewed && item && item.product_id) {
            window.HillmalayaRecentlyViewed.recordAdded({
              id: item.product_id, handle: item.handle
            });
          }
        })
        .catch(function (err) {
          // A variant that went to zero between render and click answers 422
          // with a `description`. Say so in the row — a silent re-enable reads
          // as a dead button. Only a genuine server description wins over the
          // localized fallback — `err.message` is a raw unlocalized browser
          // string on a network failure (e.g. "Failed to fetch") and must
          // never reach the customer.
          var msg = (err && typeof err.description === 'string' && err.description) ||
            t('failed', "Couldn't add that — please pick another size");
          showError(row, msg);
          // A failed add leaves NO trace in any order, so without this the
          // stock-race rate (spec target <0.5%) is unmeasurable.
          var info = rowInfo(row);
          info.attach_error = String(msg).slice(0, 120);
          track('attach_add_failed', info);
          var sel = row.querySelector('[data-attach-size]');
          btn.disabled = !!(sel && !sel.value);
        });
    }
  };

  // Delegated — bound once by the module guard above. Arrow-free and wrapped so
  // the Event is never passed into a parameterized handler.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { watchImpression(); });
  } else {
    watchImpression();
  }

  document.addEventListener('change', function (e) {
    var sel = e.target.closest ? e.target.closest('[data-attach-size]') : null;
    if (sel) { window.PXUTheme.jsAttach.onSize(sel); }
  });
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-attach-add]') : null;
    if (btn) { e.preventDefault(); window.PXUTheme.jsAttach.add(btn); }
  });
})();
